module.exports = __webpack_public_path__ + "static/tips-insured-32ef32e103ced1d84bcfec902ececdf6.png";